export const HAS_OPENED_DIETARY_PREFERENCES_MODAL_STORAGE_KEY =
  'HAS_OPENED_DIETARY_PREFERENCES_MODAL';
